import { render, staticRenderFns } from "./TiketCreate.vue?vue&type=template&id=4d7093d0&"
import script from "./TiketCreate.vue?vue&type=script&lang=js&"
export * from "./TiketCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports